// ============================================================================
// MICALI-VAZIRANI - ALGORITHM METADATA
// ============================================================================

export const meta = {
  id: 'micali-vazirani',
  name: 'Micali-Vazirani',
  category: 'Graphs',
  complexity: {
    time: 'O(√V E)',
    space: 'O(V)'
  },
  description: 'An algorithm for finding maximum matching in general graphs. It is theoretically the fastest known algorithm for this problem, though complex to implement in practice.'
};
